import { CalendarDateFormatter, DateFormatterParams } from 'angular-calendar';
import * as moment from 'moment';
import { getFirstDayOfWeek, getLastDayOfWeek } from './DateHelper';

export class CustomDateFormatter extends CalendarDateFormatter {
  // you can override any of the methods defined in the parent class

  public dayViewHour({ date, locale }: DateFormatterParams): string {
    return moment(date).format('HH:mm')+'hs';
  }

  public weekViewTitle({ date, locale }: DateFormatterParams): string {
    let first = getFirstDayOfWeek(date);
    let last = getLastDayOfWeek(date);

    return `Semana del ${first.format('DD/MM/YYYY')} al ${last.format('DD/MM/YYYY')}`;
  }
}


// WEBPACK FOOTER //
// E:/jenkins_home/workspace/_agenda-unco-front-legacy_master/frontend-web/src/app/utils/custom-date-formatter.provider.ts